const template = `
<div class="popup-info">
    <span data-sticky-template="popup-info-content">%content%</span>
</div>
`;

export default template;
